module.exports = __webpack_public_path__ + "static/media/AverageWaterDemand.83640064.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/CareIcons/AverageWaterDemand.png
// module id = 599
// module chunks = 0